import React from 'react';
import Button from '../common/Button';
import { Modal, ModalContent } from '../common';

const EndSessionModal = ({ isOpen, onClose, onEndSession, isLoading, error }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnBackdropClick={!isLoading}>
      <ModalContent size="small" constrainHeight={false} className="text-center">
        <h3 className="text-xl font-bold text-text-primary mb-4">End Session</h3>
        <p className="text-text-secondary mb-4">Are you sure you want to end this session? This will:</p>
        <ul className="text-sm text-text-secondary mb-6 list-disc list-inside space-y-1 text-left">
          <li>Mark all active/paused players as finished</li>
          <li>Preserve existing exit reasons (no-show, cancelled)</li>
          <li>Mark the session as completed</li>
          <li>Return you to the session list</li>
        </ul>

        {error && (
          <div className="bg-danger-light border border-danger/50 text-danger-dark px-4 py-2 rounded mb-4">
            {error}
          </div>
        )}

        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-center sm:gap-4">
          <Button variant="secondary" onClick={onClose} disabled={isLoading} className="w-full sm:w-auto">
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => onEndSession('completed')}
            disabled={isLoading}
            className="w-full sm:w-auto"
          >
            {isLoading ? 'Ending...' : 'End Session'}
          </Button>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default EndSessionModal;
